import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography } from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { generateVisitMetrics } from '../../utilityFunctions/DataloveUtil';
import Swal from 'sweetalert';
import CustomLoader from "../../components/CustomLoader";

export default function GroupedBarChart(props) {
    const { loginUser } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchVisitMetrics = async () => {
            setLoading(true);
            const visitMetrics = await generateVisitMetrics(loginUser.jwtToken);
            setLoading(false);

            if (!visitMetrics) {
                Swal({
                    title: "Error",
                    text: "Failed to fetch visit metrics",
                    icon: "error",
                    button: "Ok",
                });
                return;
            }

            // Sort the data chronologically by month
            const sortedData = (visitMetrics.chartData || []).sort((a, b) => {
                return a.month.localeCompare(b.month);
            });

            setData(sortedData);
        };
        fetchVisitMetrics();
    }, [loginUser.jwtToken]);

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: {xs: "start", sm: "start", md: "center"}, width: "95%", height: "90%", textAlign: "center", marginTop: { xs: "4.5rem", sm: "2rem", md: "0" } }}>
                {loading ? (
                    <CustomLoader />
                ) : (
                    <Grid container direction="row" spacing={1} sx={{display: "flex", justifyContent: "center"}}>
                        <Grid item xs={12}>
                            <Typography variant="h4" sx={{ marginTop: "2rem", fontWeight: "bold" }}>Visit Status Comparison</Typography>
                        </Grid>
                        {data && data.length > 0 ? (
                            <Grid item xs={12} sx={{width: "100%", height: 400}}>
                                <ResponsiveContainer width="100%" height={400}>
                                    <BarChart
                                        data={data}
                                        margin={{
                                            top: 20,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis 
                                            dataKey="month" 
                                            angle={-45} 
                                            textAnchor="end" 
                                            height={70}
                                            tick={{fontSize: 12}}
                                        />
                                        <YAxis />
                                        <Tooltip />
                                        <Legend />
                                        <Bar name="Scheduled" dataKey="scheduled" fill="#01929b" />
                                        <Bar name="Attended" dataKey="attended" fill="#4a3596" />
                                        <Bar name="Cancelled" dataKey="cancelled" fill="#f2736a" />
                                        <Bar name="No Show" dataKey="noShow" fill="#afafaf" />
                                    </BarChart>
                                </ResponsiveContainer>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body1">
                                    No data available.
                                </Typography>                                
                            </Grid>
                        )}
                    </Grid>
                )}           
            </Box>
        </Box>
    );
} 